export const blockIconsAndroidBattery5BarNew = (
	<span className='material-symbols-outlined'>battery_5_bar</span>
);
